import React from 'react'

type AlertProps = {
  type: 'success' | 'error'
  children: string
}

export default function Alert({ type, children }: AlertProps) {
  return (
    <div
      className={`py-1 px-4 border w-full rounded-md ${type === 'success' ? 'border-green-500 bg-green-100 text-green-900' : 'border-red-500 bg-red-100 text-red-600'}`}
    >
      {children}
    </div>
  )
}
